import {BaseMyopComponent, IMyopComponent} from "./IMyopComponent";
import {BaseMyopMessage, ExecuteComponentMethod} from "../../messages";
import {IComponentDefinitionConfig} from "../../common";
import {EnvelopedMessage} from "../../messages/EnvelopedMessage";
import {loaderOptions} from "../hostSDK.ts";

export class MyopRefComponent extends BaseMyopComponent {

    constructor(public componentDefinition: IComponentDefinitionConfig, public parent: IMyopComponent, options?: loaderOptions) {
        //TODO : check parentComponent.container...
        super(componentDefinition, parent.container, options);
    }

    hide() {
        //this.send(new ExecuteComponentMethod(arguments.callee.name));
        this.send(new ExecuteComponentMethod('hide'));
    }

    show() {
        this.send(new ExecuteComponentMethod('show'));
    }

    inspect() {
        //TODO : support real cleanup
        //console.log('ref inspect called, creating ExecuteComponentMethod inspect', document.location.href, this.id);
        return this.send(new ExecuteComponentMethod('inspect'));
    }

    setHeightBasedOnDocumentElement() {
        // @ts-ignore
        this.send(new ExecuteComponentMethod('setHeightBasedOnDocumentElement'));
    }

    setHeightBasedOnScrollHeight() {
        // @ts-ignore
        this.send(new ExecuteComponentMethod('setHeightBasedOnScrollHeight'));
    }

    onMessageReceived(incomeMessage: BaseMyopMessage): boolean {
        // if (incomeMessage.messageType === 'MutationObserverMessage') {
        //  debugger;
        //     this.setHeightBasedOnScrollHeight();
        //     return true;
        // }
        return super.onMessageReceived(incomeMessage);
    }


    send = (message: BaseMyopMessage) => {
        //console.log('ref message sending ', message);
        // @ts-ignore
        const handler = message.handler
        const cleanupHandler = super.send(message);

        // this.id will be available on the nested component
        this.parent.send(new EnvelopedMessage(this.id, message));

        // @ts-ignore
        message.handler = handler
        return cleanupHandler;
    };

    dispose = () => {
        if (this.isInitiated)
            this.send(new ExecuteComponentMethod('dispose'));
        super.dispose();
    }
}
